import { renderTeams } from './teams';
import { renderUsers } from './users';

export function showSettingsView(viewName: string): void {
    document.querySelectorAll('.settings-view').forEach((view) => {
        view.classList.remove('active');
    });

    const capitalizedViewName = viewName.charAt(0).toUpperCase() + viewName.slice(1);
    const targetView = document.getElementById('settings' + capitalizedViewName);
    if (targetView) {
        targetView.classList.add('active');
    }

    document.querySelectorAll('.settings-nav-btn').forEach((btn) => {
        btn.classList.remove('active');
    });

    const activeBtn = document.querySelector(`[data-settings="${viewName}"]`);
    if (activeBtn) {
        activeBtn.classList.add('active');
    }

    if (viewName === 'teams') {
        renderTeams();
    } else if (viewName === 'users') {
        renderUsers();
    }
}

export function wireSettingsNav(): void {
    document.querySelectorAll('[data-settings]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const view = (e.currentTarget as HTMLElement).getAttribute('data-settings');
            if (view) showSettingsView(view);
        });
    });
}
